<template>
    <el-form
        :model="form"
        :rules="rules"
        :loading="loading"
        ref="form"
        label-position="left"
        label-width="0px"
        v-loading="loading"
    >
        <el-form-item prop="parentItem.id">
        <el-select
            v-model="form.parentItem.id"
            filterable
            clearable
            placeholder="请选择上级单项"
            style="width: 100%;"
        >
            <el-option
            v-for="item in projectItems"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            >
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item prop="name">
        <el-input
            type="text"
            v-model="form.name"
            autocomplete="off"
            placeholder="单项名称"
        ></el-input>
        </el-form-item>
        <el-form-item style="width: 100%" v-if="type == 'add'">
            <el-button
                type="primary"
                style="width: 100%;border: none"
                v-on:click="add"
                >新建</el-button
            >
        </el-form-item>
        <el-form-item style="width: 100%" v-if="type == 'edit'">
            <el-button
                type="primary"
                style="width: 100%;border: none"
                v-on:click="edit"
                >更新</el-button
            >
        </el-form-item>
    </el-form>
</template>
<script>
export default {
  name: 'ProjectItemForm',

  props: {
    type: {
      type: String,
      default: ''
    },
    rules: {},
    form: {
      name: '',
      parentItem: {}
    },
    projectItems: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      loading: false
    }
  },

  methods: {
    add () {
      var _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/project_items/add', _this.form)
            .then(resp => {
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '新建成功' })
                _this.$router.replace('/project_items')
              } else {
                _this.$data.loading = false
              }
            })
        }
      })
    },

    edit () {
      var _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/project_items/edit', _this.form)
            .then(resp => {
              _this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '更新成功' })
                // _this.$router.replace('/project_items')
              }
            })
        }
      })
    }
  }
}
</script>
<style></style>
